import { Space } from '@tribeplatform/gql-client/types'
import { EntityImage } from '@tribeplatform/react-components/common/components'
import { SystemSpacesIcons } from '@tribeplatform/react-components/common/constants'
import { useRouter } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { useSiteTreeContext } from '../contexts/SiteTreeContext.js'

export function SpaceTreeItemComponent({ space }: { space: Space }) {
  const { Link } = useRouter()
  const defaultIcon = SystemSpacesIcons[space.slug]
  const context = useSiteTreeContext()

  const to = context.space?.to?.(space)

  return (
    <Link className="size-full p-2" href={to} onClick={context.onItemSelect}>
      <div className="grid grid-cols-[1rem_1fr] items-center gap-2">
        <EntityImage entity={space} defaultIcon={defaultIcon} />
        <Tooltip>
          <Tooltip.Trigger asChild>
            <div className="grid grid-cols-[auto_1fr] items-center gap-2">
              <span className="truncate">{space.name}</span>
              {space.private && <SvgIcon name="lock" className="ms-1" inline />}
            </div>
          </Tooltip.Trigger>
          <Tooltip.Panel>{space.name}</Tooltip.Panel>
        </Tooltip>
      </div>
    </Link>
  )
}
